export var AuditOperation;
(function (AuditOperation) {
    AuditOperation["INSERT"] = "INSERT";
    AuditOperation["UPDATE"] = "UPDATE";
    AuditOperation["DELETE"] = "DELETE";
})(AuditOperation || (AuditOperation = {}));
//# sourceMappingURL=audit.js.map